import React from "react"

export default function TypeMultiSelect({ value }) {
  return <div>{value} </div>
}
